// Wire shape of GET /api/namespaces/{namespaceId}/next (ScirixAPIService
// Services/Next/NextModels.cs). See docs/workspaces/next-workspace.md.

export type NextRungState = "reached" | "next" | "pending" | "off";
export type NextCategory = "missing" | "critical" | "strengthen";
export type NextKind = "fix" | "decide";
export type NextSeverity = "critical" | "high" | "medium" | "low";

export interface NextAction {
  label: string;
  /** Workspace tab id the action opens (governance, audit, advisory, ...). */
  workspace: string;
}

export interface NextRung {
  key: string;
  title: string;
  state: NextRungState;
  detail: string;
  action: NextAction | null;
}

export interface NextMember {
  id: string;
  title: string;
  anchor: string | null;
  detectedAt: string | null;
}

export interface NextGroup {
  id: string;
  category: NextCategory;
  kind: NextKind;
  severity: NextSeverity;
  confidence: "high" | "medium" | "low";
  count: number;
  score: number;
  title: string;
  why: string;
  source: string;
  canLead: boolean;
  isNew: boolean;
  members: NextMember[];
  action: NextAction;
}

export interface NextResponse {
  ladder: { rungs: NextRung[]; next: NextRung | null };
  top: NextGroup[];
  smaller: NextGroup[];
  coverage: {
    sourcesRead: string[];
    sourcesUnavailable: { source: string; reason: "feature_off" | "failed" }[];
  };
  generatedByAi: boolean;
}

export function isNextResponse(value: unknown): value is NextResponse {
  if (typeof value !== "object" || value === null) return false;
  const body = value as NextResponse;
  return (
    typeof body.ladder === "object" &&
    body.ladder !== null &&
    Array.isArray(body.ladder.rungs) &&
    Array.isArray(body.top) &&
    Array.isArray(body.smaller) &&
    typeof body.coverage === "object" &&
    body.coverage !== null
  );
}
